/**
 * StatsCard - Mobile-friendly attendance statistics card
 */
export const StatsCard = ({ icon: Icon, label, value, color }) => (
  <div className={`bg-white rounded-xl p-3 shadow-sm border-l-4 ${color}`}>
    <div className="flex items-center gap-2">
      <div className={`w-8 h-8 rounded-lg ${color.replace('border-', 'bg-').replace('-500', '-100')} flex items-center justify-center flex-shrink-0`}>
        <Icon className={`w-4 h-4 ${color.replace('border-', 'text-')}`} />
      </div>
      <div className="min-w-0">
        <p className="text-lg font-black text-gray-800 truncate">{value}</p>
        <p className="text-xs text-gray-500 truncate">{label}</p>
      </div>
    </div>
  </div>
);
